export function toApiCanadaPostalCode(input: string): string {
  // Add space or replace hyphen with space then make upper case
  return (
    input.length === 6 ? `${input.substring(0, 3)} ${input.substring(input.length - 3)}` : input.replace('-', ' ')
  ).toUpperCase();
}
